const global = globalThis;
export { global };
